(function(){
  /* Interruptor de tema claro/oscuro: invierte literalmente la
     paleta (blanco↔negro) vía [data-theme] en <html>, reutilizando
     el mismo mecanismo de tema claro/oscuro que ya tiene el header
     (theme-light / theme-dark) para que quede sincronizado, y
     recuerda la elección en localStorage. */
  try{
    var root = document.documentElement;
    var toggle = document.getElementById('td-theme-toggle');
    var header = document.querySelector('.td-header');
    /* :not([data-theme-fixed]) deja fuera secciones como .td-compat2,
       que son siempre negro mate a propósito y no deben cambiar de
       data-nav-theme cuando se pulsa el interruptor. */
    var navSections = Array.prototype.slice.call(document.querySelectorAll('[data-nav-theme]:not([data-theme-fixed])'));
    if(!toggle) return;

    var applyTheme = function(theme, silent){
      if(theme === 'dark'){ root.setAttribute('data-theme', 'dark'); }
      else{ root.removeAttribute('data-theme'); }
      navSections.forEach(function(section){ section.setAttribute('data-nav-theme', theme); });
      if(header){
        header.classList.toggle('theme-dark', theme === 'dark');
        header.classList.toggle('theme-light', theme !== 'dark');
      }
      toggle.setAttribute('aria-pressed', theme === 'dark' ? 'true' : 'false');
      toggle.setAttribute('aria-label', theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode');
      if(!silent){
        try{ localStorage.setItem('td-theme', theme); }catch(e){}
      }
    };

    /* El <script> del <head> ya dejó puesto [data-theme="dark"] si
       tocaba, para evitar el destello — aquí solo sincronizamos el
       resto de la página (header, secciones, botón) con ese estado. */
    applyTheme(root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light', true);

    toggle.addEventListener('click', function(){
      var current = root.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';
      applyTheme(current === 'dark' ? 'light' : 'dark');
    });
  }catch(e){}
})();

(function(){
  try{
    var toggle = document.getElementById('td-menu-toggle');
    var panel = document.getElementById('td-mobile-nav');
    if(!toggle || !panel) return;
    toggle.addEventListener('click', function(){
      var open = panel.hasAttribute('hidden');
      if(open){ panel.removeAttribute('hidden'); }
      else{ panel.setAttribute('hidden',''); }
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }catch(e){}
})();

(function(){
  /* Header fijo, siempre con desenfoque de cristal: cambia entre
     tema claro (fondo blanco/negro sobre texto) y tema oscuro
     (fondo negro/texto blanco) según qué sección [data-nav-theme]
     tiene justo detrás en cada momento. */
  try{
    var header = document.querySelector('.td-header');
    var sections = Array.prototype.slice.call(document.querySelectorAll('[data-nav-theme]'));
    if(!header || !sections.length) return;

    var syncHeaderHeight = function(){
      document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    };

    var updateTheme = function(){
      var probeY = header.offsetHeight + 2;
      var active = null;
      for (var i = 0; i < sections.length; i++){
        var rect = sections[i].getBoundingClientRect();
        if (rect.top <= probeY && rect.bottom > probeY){ active = sections[i]; break; }
      }
      if (!active){
        var firstRect = sections[0].getBoundingClientRect();
        active = (firstRect.top > probeY) ? sections[0] : sections[sections.length - 1];
      }
      var theme = active.getAttribute('data-nav-theme') === 'dark' ? 'dark' : 'light';
      header.classList.toggle('theme-dark', theme === 'dark');
      header.classList.toggle('theme-light', theme === 'light');
    };

    syncHeaderHeight();
    updateTheme();

    var ticking = false;
    window.addEventListener('scroll', function(){
      if(!ticking){
        window.requestAnimationFrame(function(){ updateTheme(); ticking = false; });
        ticking = true;
      }
    }, {passive:true});

    window.addEventListener('resize', function(){
      syncHeaderHeight();
      updateTheme();
    });
  }catch(e){}
})();

(function(){
  /* Selector Mini / Pro: alterna qué panel se ve, sin mover nunca el
     layout (imagen izquierda, info derecha se queda fija). */
  try{
    var tabs = Array.prototype.slice.call(document.querySelectorAll('[data-picker-tab]'));
    var panels = Array.prototype.slice.call(document.querySelectorAll('[data-picker-panel]'));
    if(!tabs.length || !panels.length) return;

    var activate = function(name){
      tabs.forEach(function(tab){
        var active = tab.getAttribute('data-picker-tab') === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });
      panels.forEach(function(panel){
        var active = panel.getAttribute('data-picker-panel') === name;
        if(active){ panel.removeAttribute('hidden'); }
        else{ panel.setAttribute('hidden',''); }
      });
    };

    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        activate(tab.getAttribute('data-picker-tab'));
      });
    });

    /* Miniaturas: cada grupo (uno por panel — Mini y Pro son
       completamente independientes entre sí) alterna qué "slide" de
       su propia galería se ve en el hueco grande, por índice. */
    var galleries = Array.prototype.slice.call(document.querySelectorAll('.td-picker__gallery'));
    galleries.forEach(function(gallery){
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-picker-thumb]'));
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-picker-slide]'));
      if(!thumbs.length || !slides.length) return;
      thumbs.forEach(function(thumb){
        thumb.addEventListener('click', function(){
          var index = parseInt(thumb.getAttribute('data-picker-index'), 10) || 0;
          thumbs.forEach(function(t){ t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          slides.forEach(function(s, i){
            s.classList.toggle('is-active', i === index);
            /* Pausa el vídeo de cualquier slide que deje de verse, para
               que no siga sonando/reproduciéndose de fondo. */
            if(i !== index){
              var vid = s.querySelector('video');
              if(vid && !vid.paused){ vid.pause(); }
            }
          });
        });
      });
    });
  }catch(e){}
})();

(function(){
  /* Bullets de Compatible Platforms: v41, antes era un tooltip
     flotante que aparecía al pasar el ratón por encima; ahora es un
     desplegable normal, como un acordeón — al pulsar la flechita, el
     detalle se despliega justo debajo (empujando el resto de puntos
     hacia abajo) y al volver a pulsar se cierra (todo vuelve a subir
     a su sitio). El alto se calcula con scrollHeight en cada apertura
     para que la transición sea exacta al contenido real, sin dejar
     hueco de más.
     v42: como máximo un punto abierto a la vez — al abrir uno se
     cierra automáticamente el que estuviera abierto, así la sección
     nunca crece más de lo que ocupa un solo bullet desplegado.
     v43: el primero ("Five preset profiles for every platform") sale
     ya desplegado por defecto al cargar la página; el resto se
     comporta exactamente igual (uno abierto como máximo). */
  try{
    var toggles = Array.prototype.slice.call(document.querySelectorAll('[data-compat-toggle]'));
    var entries = toggles.map(function(toggle){
      var item = toggle.closest('.td-compat2__item');
      var panel = item ? item.querySelector('[data-compat-panel]') : null;
      return { toggle: toggle, panel: panel };
    }).filter(function(entry){ return !!entry.panel; });

    var closeEntry = function(entry){
      entry.panel.style.maxHeight = '0px';
      entry.toggle.setAttribute('aria-expanded', 'false');
    };
    var openEntry = function(entry){
      entry.panel.style.maxHeight = entry.panel.scrollHeight + 'px';
      entry.toggle.setAttribute('aria-expanded', 'true');
    };

    entries.forEach(function(entry){
      entry.toggle.addEventListener('click', function(){
        var isOpen = entry.toggle.getAttribute('aria-expanded') === 'true';
        entries.forEach(function(other){
          if(other !== entry){ closeEntry(other); }
        });
        if(isOpen){ closeEntry(entry); }else{ openEntry(entry); }
      });
    });

    if(entries.length){ openEntry(entries[0]); }

    /* Si la ventana cambia de tamaño con el punto abierto, el texto
       puede reflowar a más o menos líneas — se recalcula el alto para
       que no se corte ni quede hueco de sobra. */
    window.addEventListener('resize', function(){
      entries.forEach(function(entry){
        if(entry.toggle.getAttribute('aria-expanded') === 'true'){
          entry.panel.style.maxHeight = entry.panel.scrollHeight + 'px';
        }
      });
    });
  }catch(e){}
})();

/* Nota: aquí NO se intercepta el envío del formulario de newsletter
   del footer (a diferencia del borrador HTML de vista previa). En
   Shopify de verdad, /contact#contact_form existe de verdad: dejamos
   que el navegador haga el POST nativo, que es lo que da de alta al
   suscriptor en Shopify Admin → Clientes. Shopify vuelve a esta misma
   página con ?customer_posted=true tras un alta correcta, así que el
   mensaje de éxito (.td-footer__success) se muestra comprobando ese
   parámetro en la URL. */
(function(){
  try{
    if(/[?&]customer_posted=true/.test(window.location.search)){
      var footer = document.querySelector('.td-footer');
      if(footer){ footer.setAttribute('data-subscribed', ''); }
    }
  }catch(e){}
})();
